var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{staticStyle:{"height":"4px"},attrs:{"variant":_vm.variant,"value":_vm.value,"max":_vm.max}})
}
var staticRenderFns = []

export { render, staticRenderFns }